import { css } from '@emotion/css'

import {
  borderRadius,
  breakpoint,
  fontSize,
  fontWeight,
  spacing,
  fontFamily,
  mediaQueryHelper,
  colors,
  hexToRgba,
} from '@offerzen/pinata-shame'

const styles = {
  container: width =>
    css({
      background: 'white',
      width: '100%',
      flex: '1 0 auto',
      minHeight: '100vh',
      marginTop: 0,
      [mediaQueryHelper(breakpoint.phone)]: {
        width,
        flex: '0 0 auto',
        boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
        marginTop: spacing.extraLarge,
        marginBottom: spacing.large,
        paddingBottom: 0,
        minHeight: 'auto',
        borderRadius: borderRadius.default,
      },
    }),

  header: css({
    fontFamily: fontFamily.heading,
    padding: spacing.large,
    borderBottom: `1px solid ${colors.mystic}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
  }),

  headerImage: css({
    width: 80,
    marginBottom: spacing.default,
  }),

  title: css({
    fontSize: fontSize.medium,
    color: colors.cornflowerBlue,
    textAlign: 'center',
    marginBottom: 0,
    fontWeight: fontWeight.bold,
  }),

  content: css({
    padding: spacing.large,
  }),
}

export default styles
